import { c as _c } from "react/compiler-runtime";
import { Divider } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
const OrDivider = () => {
  const $ = _c(8);
  const {
    t
  } = useTranslation("authentication");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Divider className="fp-auth-rule" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t(_temp);
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <span className="text-caption-2 text-tertiary">{t1}</span>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Divider className="fp-auth-rule" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2) {
    t4 = <div className="flex items-center gap-4">{t0}{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export default OrDivider;
function _temp($) {
  return $.or;
}